export default __webpack_public_path__ + "static/media/talalkozzunk.1221b471.png";